module.exports = __webpack_public_path__ + "img/edit.c8130b94.svg";